import React, { useCallback, useEffect, useState } from "react";
import { GiCheckMark } from "react-icons/gi";
import { Button, Card } from "antd";
import { PlusCircleOutlined, MinusCircleOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import DataProvider from "../../services";
import Loader from "../../components/cards/loader";
import { useNavigate } from "react-router-dom";
import { packageDetails, useAppStore } from "../../store";
import img from "../../assets/images/poweredbymtn.png";
import backgroundImg from "../../assets/images/nr1.jpg";

export default function Selectmcareplan(props: any) {
  const navigate = useNavigate();
  const { setPackage, packages, setPlan } = useAppStore();
  const [loading, setLoading] = useState<any>();
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await DataProvider.getAllPackages();
      setPackage(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [setPackage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  async function onBuy(planx: packageDetails) {
    setPlan(planx);
    navigate(`/main/billing/${planx.id}`);
  }

  return (
    <div className="w-full h-full">
      {/* MOBILE VIEW */}
      <div
        className="h-full lg:hidden flex flex-col w-full bg-cover bg-center bg-[#1A94ECB5] bg-blend-overlay relative"
        style={{ backgroundImage: `url(${backgroundImg})` }}
      >
        <div className="flex-1 overflow-y-auto px-4 py-6">
          <Card className="shadow-xl border-0 rounded-3xl bg-white/95 backdrop-blur-sm">
            <Button
              onClick={() => navigate("/main")}
              icon={<ArrowLeftOutlined />}
              className="mb-4"
              type="text"
            >
              Back
            </Button>
            <div className="mb-6">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">
                Choose a <span className="text-[#1A94EC]">Plan</span> that works for you
              </h1>
              <p className="text-gray-600">Select the perfect plan for your health needs</p>
            </div>
            {loading && packages === null ? (
              <div className="border border-solid border-gray-200 rounded-xl flex justify-center items-center h-64">
                <Loader num={1} />
              </div>
            ) : packages && packages.length > 1 ? (
              <div className="space-y-4">
                {/* Plan 1 */}
                <div className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="p-5">
                    <div
                      className="flex justify-between items-center mb-3 cursor-pointer"
                      onClick={() => setExpandedIndex(expandedIndex === 1 ? null : 1)}
                    >
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">
                          {packages[1].description}
                        </h3>
                        <p className="text-2xl font-bold text-[#1A94EC] mt-1">
                          GH¢{packages[1].price}
                          <span className="text-base font-normal text-gray-600">/month</span>
                        </p>
                      </div>
                      {expandedIndex === 1 ? (
                        <MinusCircleOutlined className="text-2xl text-gray-400" />
                      ) : (
                        <PlusCircleOutlined className="text-2xl text-gray-400" />
                      )}
                    </div>
                    <p className="text-sm text-gray-600 mb-4">
                      {packages[1].offers.map((v: any, idx: any) => (
                        <span key={idx}>
                          {v.name}
                          {v.name === "Telemedicine" ? <span className="mx-1">+</span> : null}
                        </span>
                      ))}
                    </p>
                    {expandedIndex === 1 && (
                      <div className="pt-4 space-y-4 border-t border-gray-100 animate-in slide-in-from-top-2 duration-300">
                        {packages[1].offers.map((itx: any, idx: any) => (
                          <div key={idx} className="pt-4">
                            <h4 className="font-semibold text-gray-900 mb-2">{itx.name}</h4>
                            <ul className="space-y-2">
                              {itx.list.map((i: any, idxx: any) => (
                                <li key={idxx} className="flex items-start">
                                  <GiCheckMark
                                    size={18}
                                    className="text-[#1A94EC] mr-2 mt-0.5 flex-shrink-0"
                                  />
                                  <span className="text-gray-700">{i}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                        <Button
                          onClick={() => onBuy(packages[1])}
                          size="large"
                          className="bg-gradient-to-r from-[#1A94EC] to-[#0d7bc4] w-full h-12 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0d7bc4] hover:to-[#1A94EC] transition-all mt-4"
                        >
                          Buy now
                        </Button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Plan 2 */}
                <div className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="p-5">
                    <div
                      className="flex justify-between items-center mb-3 cursor-pointer"
                      onClick={() => setExpandedIndex(expandedIndex === 0 ? null : 0)}
                    >
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">
                          {packages[0].description}
                        </h3>
                        <p className="text-2xl font-bold text-[#1A94EC] mt-1">
                          GH¢{packages[0].price}
                          <span className="text-base font-normal text-gray-600">/month</span>
                        </p>
                      </div>
                      {expandedIndex === 0 ? (
                        <MinusCircleOutlined className="text-2xl text-gray-400" />
                      ) : (
                        <PlusCircleOutlined className="text-2xl text-gray-400" />
                      )}
                    </div>
                    <p className="text-sm text-gray-600 mb-4">
                      Telemedicine + Health Insurance
                    </p>
                    {expandedIndex === 0 && (
                      <div className="pt-4 space-y-4 border-t border-gray-100 animate-in slide-in-from-top-2 duration-300">
                        {packages[0].offers.map((itx: any, idx: any) => (
                          <div key={idx} className="pt-4">
                            <h4 className="font-semibold text-gray-900 mb-2">{itx.name}</h4>
                            <ul className="space-y-2">
                              {itx.list.map((i: any, idxx: any) => (
                                <li key={idxx} className="flex items-start">
                                  <GiCheckMark
                                    size={18}
                                    className="text-[#1A94EC] mr-2 mt-0.5 flex-shrink-0"
                                  />
                                  <span className="text-gray-700">{i}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                        <Button
                          onClick={() => onBuy(packages[0])}
                          size="large"
                          className="bg-gradient-to-r from-[#1A94EC] to-[#0d7bc4] w-full h-12 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0d7bc4] hover:to-[#1A94EC] transition-all mt-4"
                        >
                          Buy now
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="border border-gray-200 rounded-xl flex justify-center items-center h-64">
                <p className="text-gray-500">No plans available</p>
              </div>
            )}
            <div className="flex justify-center mt-8">
              <img src={img} alt="care" className="h-12 rounded-l-lg" />
            </div>
          </Card>
        </div>
      </div>

      {/* DESKTOP VIEW */}
      <div className="h-full w-full lg:flex hidden">
        {/* Left Side - Branding */}
        <div
          className="h-full w-[50%] bg-center relative flex flex-col justify-between p-8 bg-cover bg-[#1A94ECB5] bg-blend-overlay"
          style={{ backgroundImage: `url(${backgroundImg})` }}
        >
          <div className="relative z-10 text-white">
            <h1 className="text-6xl font-bold mb-4 leading-tight">
              Choose Your Plan
            </h1>
            <p className="text-2xl font-light opacity-90">
              Select the perfect plan for your health needs
            </p>
          </div>
        </div>

        {/* Right Side - Plans */}
        <div className="h-full w-[50%] flex items-start justify-center bg-gradient-to-br from-gray-50 via-white to-blue-50 pt-0 px-12 pb-12 overflow-y-auto">
          <div className="w-full max-w-2xl">
            <Card
              className="shadow-2xl border-0 rounded-3xl bg-white/95 backdrop-blur-sm"
              styles={{
                body: { padding: "1.5rem 2.5rem 2.5rem" },
              }}
            >
              <Button
                onClick={() => navigate("/main")}
                icon={<ArrowLeftOutlined />}
                className="mb-6"
                type="text"
              >
                Back
              </Button>
              <div className="mb-8">
                <h1 className="text-5xl font-bold text-gray-900 mb-3 leading-tight">
                  Choose a <span className="text-[#1A94EC]">Plan</span> that works for you
                </h1>
                <p className="text-gray-600 text-lg">
                  Select the perfect plan for your health needs
                </p>
              </div>
              {loading && packages === null ? (
                <div className="border border-gray-200 rounded-xl flex justify-center items-center h-64">
                  <Loader num={1} />
                </div>
              ) : packages && packages.length > 1 ? (
                <div className="space-y-6">
                  {/* Plan 1 */}
                  <div className="border-2 border-gray-200 rounded-2xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-all hover:border-[#1A94EC]/30">
                    <div className="p-6">
                      <div
                        className="flex justify-between items-center mb-4 cursor-pointer"
                        onClick={() => setExpandedIndex(expandedIndex === 1 ? null : 1)}
                      >
                        <div>
                          <h3 className="text-2xl font-bold text-gray-900">
                            {packages[1].description}
                          </h3>
                          <p className="text-3xl font-bold text-[#1A94EC] mt-2">
                            GH¢{packages[1].price}
                            <span className="text-lg font-normal text-gray-600">/month</span>
                          </p>
                        </div>
                        {expandedIndex === 1 ? (
                          <MinusCircleOutlined className="text-3xl text-gray-400" />
                        ) : (
                          <PlusCircleOutlined className="text-3xl text-gray-400" />
                        )}
                      </div>
                      <p className="text-base text-gray-600 mb-4">
                        {packages[1].offers.map((v: any, idx: any) => (
                          <span key={idx}>
                            {v.name}
                            {v.name === "Telemedicine" ? <span className="mx-1">+</span> : null}
                          </span>
                        ))}
                      </p>
                      {expandedIndex === 1 && (
                        <div className="pt-6 space-y-6 border-t border-gray-200 animate-in slide-in-from-top-2 duration-300">
                          {packages[1].offers.map((itx: any, idx: any) => (
                            <div key={idx}>
                              <h4 className="font-semibold text-lg text-gray-900 mb-3">{itx.name}</h4>
                              <ul className="space-y-2">
                                {itx.list.map((i: any, idxx: any) => (
                                  <li key={idxx} className="flex items-start">
                                    <GiCheckMark
                                      size={20}
                                      className="text-[#1A94EC] mr-3 mt-0.5 flex-shrink-0"
                                    />
                                    <span className="text-gray-700">{i}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                          <Button
                            onClick={() => onBuy(packages[1])}
                            size="large"
                            className="bg-gradient-to-r from-[#1A94EC] to-[#0d7bc4] w-full h-14 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0d7bc4] hover:to-[#1A94EC] transition-all mt-6 text-base"
                          >
                            Buy now
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Plan 2 */}
                  <div className="border-2 border-gray-200 rounded-2xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-all hover:border-[#1A94EC]/30">
                    <div className="p-6">
                      <div
                        className="flex justify-between items-center mb-4 cursor-pointer"
                        onClick={() => setExpandedIndex(expandedIndex === 0 ? null : 0)}
                      >
                        <div>
                          <h3 className="text-2xl font-bold text-gray-900">
                            {packages[0].description}
                          </h3>
                          <p className="text-3xl font-bold text-[#1A94EC] mt-2">
                            GH¢{packages[0].price}
                            <span className="text-lg font-normal text-gray-600">/month</span>
                          </p>
                        </div>
                        {expandedIndex === 0 ? (
                          <MinusCircleOutlined className="text-3xl text-gray-400" />
                        ) : (
                          <PlusCircleOutlined className="text-3xl text-gray-400" />
                        )}
                      </div>
                      <p className="text-base text-gray-600 mb-4">
                        Telemedicine + Health Insurance
                      </p>
                      {expandedIndex === 0 && (
                        <div className="pt-6 space-y-6 border-t border-gray-200 animate-in slide-in-from-top-2 duration-300">
                          {packages[0].offers.map((itx: any, idx: any) => (
                            <div key={idx}>
                              <h4 className="font-semibold text-lg text-gray-900 mb-3">{itx.name}</h4>
                              <ul className="space-y-2">
                                {itx.list.map((i: any, idxx: any) => (
                                  <li key={idxx} className="flex items-start">
                                    <GiCheckMark
                                      size={20}
                                      className="text-[#1A94EC] mr-3 mt-0.5 flex-shrink-0"
                                    />
                                    <span className="text-gray-700">{i}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                          <Button
                            onClick={() => onBuy(packages[0])}
                            size="large"
                            className="bg-gradient-to-r from-[#1A94EC] to-[#0d7bc4] w-full h-14 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-[#0d7bc4] hover:to-[#1A94EC] transition-all mt-6 text-base"
                          >
                            Buy now
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="border border-gray-200 rounded-xl flex justify-center items-center h-64">
                  <p className="text-gray-500">No plans available</p>
                </div>
              )}
              <div className="flex justify-center mt-8">
                <img src={img} alt="care" className="h-16 rounded-l-lg" />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
